import { FetchHttpClient } from '@automation-suite/shared-clients-fetch-http';

export const widgetFetchHttpClient = new FetchHttpClient();
